import React, { useRef, useState, useEffect } from "react";
import logoNdovu from "../../assets/img/main_landing_logo.png";
import svg19 from "../../assets/svg/svg19.svg";
import svg39 from "../../assets/svg/svg39.svg";
import { useNavigate } from "react-router-dom";

function Header({ active, setActive, activeTab, setActiveTab }) {
  const menuRef = useRef(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);

  const navigate = useNavigate();

  const menuItems = [
    { name: "Home", id: "home" },
    {
      name: "Services",
      id: "services",
      hasDropdown: true,
      dropdownItems: [
        { name: "Bulk Payment", id: "bulk-payment" },
        { name: "Bill & Supplier Settlement", id: "bill-settlement" },
        { name: "Petty Cash Management", id: "petty-cash" },
        { name: "Airtime & Data Bundles", id: "airtime-data" },
      ],
    },
    { name: "Utility Bill Pay", id: "utility" },
    { name: "About Us", id: "about" },
  ];

   
   const handleLogin = async () => {
    window.location.href="https://app.ndovupay.org/#/login"  
   
  };


  const handleLoginMobile = async () => {
    await setIsMobileMenuOpen(false);
    await handleLogin()
  };

  const handleClick = (id) => {
    setActive(id);
    const container = document.getElementById("landing-container");

    if (id === "home") {
      if (container) {
        container.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } else {
      if (container) {
        container.scrollTo({ top: 0, behavior: "auto" });
        setTimeout(() => {
          document
            .getElementById(id)
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      } else {
        window.scrollTo({ top: 0, behavior: "auto" });
        setTimeout(() => {
          document
            .getElementById(id)
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      const container = document.getElementById("landing-container");
      const scrollPosition = container ? container.scrollTop : window.scrollY;

      if (scrollPosition > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    const container = document.getElementById("landing-container");
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    } else {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);

  return (
    <div
      className={`py-[1.25rem] font-lexendS fixed top-0 left-0 right-0 z-[9999] transition-all duration-300 ${
        isScrolled ? "bg-white shadow-md" : "bg-transparent"
      }`}
      style={
        isScrolled
          ? {
              backgroundColor: "#ffffff",
              backgroundImage: "none",
            }
          : {}
      }
    >
      <div className="lg:px-[5.69rem] px-3 flex items-center justify-between">
        <img
          src={logoNdovu}
          alt="logoNdovu"
          className="h-8 md:h-10 lg:h-auto"
        />

        <div className="hidden lg:flex w-[13.125rem] h-[3rem] justify-center rounded-[6.25rem] border border-[#000] overflow-hidden">
          {["business", "personal"]?.map((tab) => (
            <button
              key={tab}
              onClick={() => {
                setActiveTab(tab);
                setActive("home");
              }}
              className={`flex-1 flex justify-center items-center text-sm py-[0.6875rem] px-[1rem] ${
                activeTab === tab ? "bg-[#FFB600]" : "bg-transparent"
              } ${
                tab === "business"
                  ? "rounded-l-[6.25rem]"
                  : "rounded-r-[6.25rem]"
              }`}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </div>

        {/* Menu Items */}
        <ul ref={menuRef} className="hidden lg:flex items-center gap-[1.5rem]">
          {menuItems?.map((item) => {
            const isActiveDropdownItem =
              item.hasDropdown &&
              item.dropdownItems?.some(
                (dropdownItem) => dropdownItem.id === active
              );
            const isActive = active === item?.id || isActiveDropdownItem;

            return (
              <li key={item?.id} className="relative group">
                <div
                  onClick={() => !item.hasDropdown && handleClick(item?.id)}
                  className={`cursor-pointer hover:text-[#FFB600] transition-colors ${
                    isActive ? "text-[#FFB600] font-semibold" : ""
                  }`}
                >
                  {item?.name}
                </div>

                {/* Services Dropdown */}
                {item.hasDropdown && (
                  <div className="absolute top-full left-0 mt-2 bg-white shadow-lg rounded-lg py-2 min-w-[15rem] z-[10000] opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                    {item.dropdownItems?.map((dropdownItem) => (
                      <div
                        key={dropdownItem.id}
                        onClick={() => {
                          setActive("services");
                          handleClick(dropdownItem.id);
                        }}
                        className="px-4 py-2 hover:bg-[#FFB600]/10 hover:text-[#FFB600] cursor-pointer transition-colors"
                      >
                        {dropdownItem.name}
                      </div>
                    ))}
                  </div>
                )}
              </li>
            );
          })}
        </ul>

        {/* CTA Buttons */}
        <div className="hidden lg:flex items-center gap-[1.25rem]">
          <button
            className="hover:text-[#FFB600] transition-colors"
            onClick={handleLogin}
          >
            Sign In
          </button>
          <button
            className="rounded-[6.25rem] border border-[#000] flex w-[11.5625rem] h-[3rem] py-[.5rem] px-[1.25rem] justify-center items-center hover:bg-[#FFB600] transition-colors"
            onClick={() => setActive("contact")}
          >
            Contact Us
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="lg:hidden flex items-center justify-center z-50 relative"
          aria-label="Toggle menu"
        >
          <img
            src={isMobileMenuOpen ? svg39 : svg19}
            alt="menu"
            className="w-8 h-8"
          />
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="lg:hidden absolute left-0 right-0 top-full bg-white/95 backdrop-blur-md z-40 shadow-lg">
          <div className="px-6 py-6 flex flex-col gap-6">
            {/* Business/Personal Toggle - Mobile */}
            <div className="w-full max-w-[13.125rem] flex h-[3rem] justify-center rounded-[6.25rem] border border-[#000] overflow-hidden">
              {["business", "personal"]?.map((tab) => (
                <button
                  key={tab}
                  onClick={() => {
                    setActiveTab(tab);
                    setActive("home");
                    setIsMobileMenuOpen(false);
                  }}
                  className={`flex-1 flex justify-center items-center text-sm py-[0.6875rem] px-[1rem] ${
                    activeTab === tab ? "bg-[#FFB600]" : "bg-transparent"
                  } ${
                    tab === "business"
                      ? "rounded-l-[6.25rem]"
                      : "rounded-r-[6.25rem]"
                  }`}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div>

            {/* Menu Items - Mobile */}
            <ul className="flex flex-col items-start gap-4 pl-2">
              {menuItems?.map((item) => {
                const isActiveDropdownItem =
                  item.hasDropdown &&
                  item.dropdownItems?.some(
                    (dropdownItem) => dropdownItem.id === active
                  );
                const isActive = active === item?.id || isActiveDropdownItem;

                return (
                  <li key={item?.id} className="w-full">
                    {item.hasDropdown ? (
                      <div className="flex flex-col gap-2">
                        <div
                          onClick={() =>
                            setServicesDropdownOpen(!servicesDropdownOpen)
                          }
                          className={`cursor-pointer text-lg hover:text-[#FFB600] transition-colors font-medium ${
                            isActive ? "text-[#FFB600]" : "text-[#1E191B]"
                          }`}
                        >
                          {item?.name} {servicesDropdownOpen ? "▲" : "▼"}
                        </div>
                        {servicesDropdownOpen && (
                          <div className="pl-4 flex flex-col gap-2">
                            {item.dropdownItems?.map((dropdownItem) => (
                              <div
                                key={dropdownItem.id}
                                onClick={() => {
                                  setActive("services");
                                  handleClick(dropdownItem.id);
                                  setIsMobileMenuOpen(false);
                                  setServicesDropdownOpen(false);
                                }}
                                className="cursor-pointer text-base hover:text-[#FFB600] transition-colors text-[#4F4770]"
                              >
                                {dropdownItem.name}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          handleClick(item?.id);
                          setIsMobileMenuOpen(false);
                        }}
                        className={`cursor-pointer text-lg hover:text-[#FFB600] transition-colors font-medium ${
                          isActive ? "text-[#FFB600]" : "text-[#1E191B]"
                        }`}
                      >
                        {item?.name}
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>

            {/* CTA Buttons - Mobile */}
            <div className="flex flex-col items-start gap-4 pl-2">
              <button
                onClick={() => handleLoginMobile()}
                className="text-lg hover:text-[#FFB600] transition-colors"
              >
                Sign In
              </button>
              <button
                onClick={() => {
                  setActive("contact");
                  setIsMobileMenuOpen(false);
                }}
                className="rounded-[6.25rem] border border-[#000] flex w-full max-w-[11.5625rem] h-[3rem] py-[.5rem] px-[1.25rem] justify-center items-center hover:bg-[#FFB600] transition-colors"
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
